import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { extendObservable, action } from 'mobx'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import NoContent from '@components/Error/NoContent'
import Pagination from '@components/Pagination'

import WidgetBox from '../WidgetBox'

class Bookmarks extends Component {
  static propTypes = {
    dashboardStore: PropTypes.object
  }

  constructor (props) {
    super(props)

    extendObservable(this, {
      limit: 10,
      page: 1
    })
  }

  changePage = action(page => {
    this.page = page
  })

  renderProjects = () => {
    const { bookmarkedProjects } = this.props.dashboardStore

    const scope = this.page * this.limit
    const offset = scope - this.limit

    return bookmarkedProjects.slice(offset, scope).map(project => {
      return (
        <div className='row' key={project.id}>
          <Link to={'/project/' + project.id}>
            <span>{project.projectName}</span>
          </Link>
        </div>
      )
    })
  }

  render () {
    const { bookmarkedProjects } = this.props.dashboardStore
    if (!bookmarkedProjects || bookmarkedProjects.length < 1) {
      return (
        <WidgetBox label='Bookmarks'>
          <div className='bookmarks-content bookmarks-no-content'>
            <NoContent label="You don't have any bookmarks yet" />
          </div>
        </WidgetBox>
      )
    }

    return (
      <WidgetBox label='Bookmarks'>
        <div className='bookmarks-content'>
          <div className='bookmarks-inner'>{this.renderProjects()}</div>
          {bookmarkedProjects && bookmarkedProjects.length > this.limit ? (
            <Pagination
              className='widget-table__pagination'
              total={bookmarkedProjects.length}
              perPage={this.limit}
              page={this.page}
              onChange={this.changePage}
              disableArrows
            />
          ) : null}
        </div>
      </WidgetBox>
    )
  }
}

export default inject('dashboardStore')(observer(Bookmarks))
